import lozad from "lozad";
import { swipeForWindows } from "javascripts/webpage/swipe-for-windows";
import { collapseFortravelReviews } from "javascripts/webpage/collapse-fortravel-reviews";
import { unmaskSlash } from "javascripts/webpage/link";
import { bindMicromodalEventTrigger } from "javascripts/micromodal";

document.addEventListener("DOMContentLoaded", () => {
  function fetchSecondaryReviews() {
    const wrapper = document.querySelector(".js-secondary-reviews-wrapper");
    fetch(unmaskSlash(document.querySelector(".js-fetch-url").dataset.fetchUrl), { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then((response) => {
        if (!response.ok) {
          throw "ErrorException";
        }
        return response.json();
      })
      .then((data) => {
        if (data.html) {
          wrapper.innerHTML = data.html;
          const addedElements = wrapper.querySelectorAll(".js-lazy:not([data-loaded])");
          const newObserver = lozad(addedElements, {
            rootMargin: "200% 400%",
          });
          newObserver.observe();
          bindMicromodalEventTrigger(wrapper);
          swipeForWindows();
          collapseFortravelReviews(wrapper);
        }
      })
      .catch(() => {
        wrapper.innerHTML = `
          <div class="c-no-results">
            <h3 class="c-no-results__heading">サーバーエラー</h3>
            <p class="c-no-results__description">
              ご迷惑をおかけし申し訳ございません。<br>
              ただいまサイトへのアクセスが混み合っております。<br>
              しばらく時間をおいてから再度ご利用ください。
            </p>
          </div>`;
      });
  }

  const fetchButton = document.querySelector(".js-fetch-secondary-reviews");
  if (fetchButton) {
    fetchButton.addEventListener("click", () => {
      fetchSecondaryReviews();
    });
  }
});
